<template>
  <div class="page-container" ref="redBerries" id="redBerriescontainer" v-images-loaded="loaded">
    <div class="bigscroller">
      <router-link  class="home-icon-container" :to="{ name: 'home' }"> 
        <img class="home-icon" :src="homeIcon" alt="home">
      </router-link>
      <Menu />
      <MobileMenu />
      <section id="redBerries">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="bannerRed"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="ritualRed">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="ritualRed"></router-view>
         <router-view name="dritualRed"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="mixologiaRed">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="mixologiaRed"></router-view>
        <router-view name="dmixologiaRed"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="maridajeRed">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="maridajeRed"></router-view>
        <router-view name="othersRed"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <div class="mRetailers">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import MobileMenu from "@/components/MobileMenu";
import Menu from "@/components/Menu";
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
import Footer from "@/components/FooterHome";
import tagFunctions from '@/utils/tagFunctions.js'
import homeIcon from "@/assets/home-icon.png"
import imagesLoaded from 'vue-images-loaded'

export default {
  name: "redBerries",
  props: ["id"],
  components: {
    MobileMenu,
    Footer,
    Menu

  },
    directives: {
    imagesLoaded
},
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion",
    ]),
  },
  created() {},
  data() {
    return {
      baseRoute: 'redBerries',
      showModal: false,
      wichModal: "terms",
      fixedLel: true,
      homeIcon
    };
  },
  mounted() {
        this.setLoadStatus({status: false})
    tagFunctions.evPageViewPush('Red Berries')
    //this.checkRouteForInitialScroll();
    VueScrollTo.scrollTo(`#app`, 1, {
          container: "body",
          easing: "linear",
          offset: 0,
          force: true,
          cancelable: true,
          // onStart: function(element) {},
          // onDone: function(element) {},
          // onCancel: function() {},
          x: false,
          y: true,
        });
  },
  methods: {
     loaded(){
      this.setLoadStatus({status: true})
    },
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling",
            setLoadStatus: "setLoadStatus"
    }),
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
      this.$router.push({ name: entry.target.offsetParent.id }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
        this.setActiveSection({
          willScroll: false,
          section: entry.target.offsetParent.id==this.$route.name?'':this.baseRoute+'/'+entry.target.offsetParent.id,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/RedBerries.scss";
@import "~@/styles/variables.scss";
</style>